import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SegmentTracker from "../plugins/segment-tracker";
import VueI18n from "vue-i18n";
import Vueform from '@vueform/vueform';
import vueformConfig from '../../../vueform.config';
import Teleport from 'vue2-teleport';

Vue.prototype.$axios = axios;
require('./components/Form');
require('./components/ValidatedField');
Vue.component('signature-field', require('./components/SignatureField').default);
require('./components/BookingWidget');
const hostedAppSelector = '#hosted_app';

Vue.use(VueI18n);
Vue.use(SegmentTracker);
Vue.use(Vueform, vueformConfig);
Vue.component('Teleport', Teleport);

function loadLang(cb) {
    function readTextFile(file, callback) {
        let rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        };
        rawFile.send(null);
    }

    readTextFile(window?.sdata?.vueLangFilePath, function (text) {
        const Messages = JSON.parse(text);
        cb(Messages);
    });
}

function launch(messages) {
    // Create VueI18n instance with options
    let lang = window.sdata.language || (process.env.MIX_APP_LANG || 'en');

    const i18n = new VueI18n({
        locale: lang,
        fallbackLocale: 'default',
        messages,
    });

    // Load hosted form
    if (document.querySelector(hostedAppSelector)) {
        const app = new Vue({
            el: hostedAppSelector,
            i18n,
            components: {Loading},
            data() {
                return {
                    isLoading: false
                }
            },
            created() {
                this.$analytics.identifyUser(sdata.user, sdata.currentTeam);
                this.$analytics.trackCustomPageView();
            },
            mounted() {
                // vuejs-datepicker doesn't forward aria-label to its inner <input>, so set it
                // from the associated <label for> (or placeholder) to give the control a name.
                // The datepickers live inside nested async components, so retry a few ticks.
                const labelDatepickers = () => {
                    let pending = 0;
                    document.querySelectorAll('.vdp-datepicker input').forEach((input) => {
                        if (input.hasAttribute('aria-label')) return;
                        const label = input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
                        const name = (label && label.textContent.trim()) || input.getAttribute('placeholder');
                        if (name) input.setAttribute('aria-label', name);
                        else pending++;
                    });
                    return pending;
                };
                let tries = 0;
                const tick = () => {
                    labelDatepickers();
                    if (++tries < 5) setTimeout(tick, 200);
                };
                this.$nextTick(tick);
            }
        });
    }

    Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
    };
}

loadLang(launch);
